import { Dialog, TextField, PrimaryButton, Stack } from '@fluentui/react';
import React from 'react';
import NavigationHelper from '../utils/NavigationHelper';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from "../../state";
import { clearDebitorRuleSets, loadDebitorSettings, setDebitorSettings } from '../../state/debitorRuleSets/action';
import { getDebitorSettings } from '../../state/action';
interface EditDebitorProps {
    debitor: DebitorRuleSet;
   
}
const EditDebitor: React.FC<EditDebitorProps> = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const debitorSettings = useSelector(getDebitorSettings);
    const [contactNumber, setContactNumber] = React.useState('');
    const [contactPage, setContactPage] = React.useState('');

    React.useEffect(() => {
        dispatch(loadDebitorSettings(props.debitor.debitor));
    }, [props, dispatch]);

    React.useEffect(() => {
        if(debitorSettings)
        {
            setContactNumber(debitorSettings.contactNumber);
            setContactPage(debitorSettings.contactPage);
        }
       
    }, [debitorSettings]);

    const closeDialog = () => {
        dispatch(clearDebitorRuleSets());
        NavigationHelper.pushRoute("DEBITOR_RULE_SET");
    };

    const handleSave = () => {
        dispatch(setDebitorSettings({debitorNo: props.debitor.debitor, contactNumber, contactPage }));
        closeDialog();
    };

    return (
        <Dialog
            hidden={false}
            onDismiss={closeDialog}
            maxWidth={450}
            minWidth={300}
            dialogContentProps={{
                title: `Setting for  ${props.debitor.insurrance} `,
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <TextField
                    label="Kontakt Nummer"
                    value={contactNumber}
                    onChange={(_, v) => setContactNumber(v || '')}
                />
                <TextField
                    label="Kontakt Side"
                    value={contactPage}
                    onChange={(_, v) => setContactPage(v || '')}
                />
                <Stack horizontal tokens={{ childrenGap: 12 }} style={{ marginTop: 24, justifyContent: 'flex-end' }}>
                    <PrimaryButton onClick={handleSave}>Gem</PrimaryButton>
                    <PrimaryButton onClick={closeDialog} style={{ background: '#eee', color: '#333' }}>Luk</PrimaryButton>
                </Stack>
            </div>
        </Dialog>
    );
};

export default EditDebitor;